<div class="tour-title-wrapper">
    <span multilang class="tour-title">Veranstalter</span>
</div>

<ng-container *ngTemplateOutlet="tourOperatorList?.length > 0 ? extern : all"></ng-container>

<ng-template #extern>
    <div class="tour-wrapper">
        <ng-container *ngFor="let item of tourOperatorListAEx | slice:0:slicenbr">
            <button class="tour-item-wrapper-ext" (click)="selected(item)" matRipple>
                <div>
                    <mat-icon class="tour-item-icon ">{{selectedList.indexOf(item.code) >= 0 ? 'check_box' :
                        'check_box_outline_blank'}}</mat-icon>
                </div>
                <div class="bestprc">
                    <span multilang class="tour-item-name-ext">{{item.name + ' ' + item.code}}</span>
                    <span multilang class="bestprcit">ab {{item.bestPricePerPerson?.value + ' ' +
                        item.bestPricePerPerson?.currency}}
                        p.P.</span>
                </div>
            </button>
        </ng-container>
        <ng-container *ngIf="tourOperatorList.length > 5">
            <ng-container *ngIf="(slicenbr < tourOperatorList.length) else less">
                <button class="showallbtn" (click)="showMore(tourOperatorList.length)" matRipple>
                    <span multilang>alle {{tourOperatorList.length}} anzeigen</span>
                </button>
            </ng-container>
            <ng-template #less>
                <button class="showallbtn" (click)="showMore(5)" matRipple>
                    <span multilang>weniger anzeigen</span>
                </button>
            </ng-template>
        </ng-container>
    </div>
</ng-template>

<ng-template #all>
    <div class="tour-wrapper" *ngIf="tourOperatorListAll?.length > 0">
        <ng-container *ngFor="let op of tourOperatorListAll | slice:0:slicenbr">
            <ng-container *ngIf="op.aktiv">
                <button class="tour-item-wrapper" (click)="selected(op)" matRipple>
                    <div>
                        <mat-icon class="tour-item-icon ">{{selectedList.indexOf(op.code) >= 0 ? 'check_box' :
                            'check_box_outline_blank'}}</mat-icon>
                    </div>
                    <span multilang class="tour-item-name">{{op.name + ' ' + op.code}}</span>
                </button>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="tourOperatorListAll.length > 5">
            <ng-container *ngIf="(slicenbr < tourOperatorListAll.length) else less">
                <button class="showallbtn" (click)="showMore(tourOperatorListAll.length)" matRipple>
                    <span multilang>alle {{tourOperatorListAll.length}} anzeigen</span>
                </button>
            </ng-container>
            <ng-template #less>
                <button class="showallbtn" (click)="showMore(5)" matRipple>
                    <span multilang>weniger anzeigen</span>
                </button>
            </ng-template>
        </ng-container>
    </div>
</ng-template>